import React from 'react'
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
export const TawkToMessenger = () => {
  return <TawkMessengerReact widgetId='default' propertyId='5b6e32cfafc2c34e96e7792b'/>
}